<template>
	<div id="app">
		<Header user=loggedIn />
		<router-view />
		<Footer />
	</div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default {
	name: 'App',
	components: {
		Header,
		Footer
	},
	data() {
		return {
			loggedIn: localStorage.getItem('loggedIn')
		}
	}
}
</script>
